import {
  SectionContainerType,
  SectionInterface,
} from 'common/components/entities/Section/types/SectionInterface'
import SectionUi from 'common/components/entities/Section/ui/SectionUi'
import React, { ReactNode } from 'react'
import SectionContainerUi from './ui/SectionContainerUi'

interface SectionProps
  extends Pick<
      SectionInterface,
      | 'background'
      | 'mobileBackground'
      | 'containerBackgroundColor'
      | 'mobileContainerBackgroundColor'
    >,
    SectionContainerType {
  htmlAttrId: string
  children: ReactNode
  backgroundImage: string
  mobileBackgroundImage: string
  width: string | undefined
}

const Section = ({
  htmlAttrId,
  backgroundImage,
  mobileBackgroundImage,
  background,
  mobileBackground,
  backgroundColor,
  mobileBackgroundColor,
  mobilePadding,
  padding,
  boxShadow,
  mobileBoxShadow,
  width,
  containerBackgroundColor,
  mobileContainerBackgroundColor,
  children,
}: SectionProps) => {
  return (
    <SectionUi
      htmlAttrId={htmlAttrId}
      backgroundImage={backgroundImage}
      mobileBackgroundImage={mobileBackgroundImage}
      backgroundColor={backgroundColor}
      mobileBackgroundColor={mobileBackgroundColor}
      padding={padding}
      mobilePadding={mobilePadding}
      boxShadow={boxShadow}
      mobileBoxShadow={mobileBoxShadow}
      background={background}
      mobileBackground={mobileBackground}
    >
      <SectionContainerUi
        width={width}
        backgroundColor={containerBackgroundColor}
        mobileBackgroundColor={mobileContainerBackgroundColor}
      >
        {children}
      </SectionContainerUi>
    </SectionUi>
  )
}

export default Section
